var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiNutrition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 21C25.6667 22.2377 25.175 23.4247 24.2999 24.2998C23.4247 25.175 22.2377 25.6667 21 25.6667H16.3334C15.0957 25.6667 13.9087 25.175 13.0335 24.2998C12.1584 23.4247 11.6667 22.2377 11.6667 21V18.6667H25.6667V21ZM4.66671 3.5H16.3334C16.9522 3.5 17.5457 3.74583 17.9833 4.18342C18.4209 4.621 18.6667 5.21449 18.6667 5.83333V16.3333H9.33337V22.1667H4.66671C4.04787 22.1667 3.45438 21.9208 3.01679 21.4832C2.57921 21.0457 2.33337 20.4522 2.33337 19.8333V5.83333C2.33337 5.21449 2.57921 4.621 3.01679 4.18342C3.45438 3.74583 4.04787 3.5 4.66671 3.5ZM4.66671 7V9.33333H7.00004V7H4.66671ZM16.3334 9.33333V7H9.33337V9.33333H16.3334ZM4.66671 11.6667V14H7.00004V11.6667H4.66671ZM9.33337 11.6667V14H16.3334V11.6667H9.33337ZM4.66671 16.3333V18.6667H7.00004V16.3333H4.66671Z",
    fill: "#50CD89"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiNutrition);
export default __webpack_public_path__ + "static/media/mdi_nutrition.621f00a8e4f75e04a743a3fdca158f7c.svg";
export { ForwardRef as ReactComponent };